module.exports = "<div class=\"qd-add-to-google-calendar\">\n\t<slot :calendarUrl=\"calendarUrl\"></slot>\n</div>\n"